import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from "../../config/httpConfig";


export const getUsersWallet = createAsyncThunk(
    "wallets/getUsersWallet",
    async () => {
        const response = await axios.get(
            `/api/admin/getUsersWallet`
        );
        return response.response;
    }
)


export const getBusEntWallet = createAsyncThunk(
    "wallets/getBusEntWallet",
    async () => {
        const response = await axios.get(
            `/api/admin/getBusEntWallet`
        );
        return response.response;
    }
)

export const getPlatformWallets = createAsyncThunk(
    "wallets/getPlatformWallets",
    async () => {
        const response = await axios.get(
            `/api/admin/getPoolingWallet`
        );
        return response.response;
    }
)

export const getKarncyWallets = createAsyncThunk(
    "wallets/getKarncyWallets",
    async () => {
        const response = await axios.get(
            `/api/admin/getKarncyPayoutWallet`
        );
        return response.response;
    }
)

export const getTransactions = createAsyncThunk(
    "wallets/getTransactions",
    async ({ vaAccountId, busEntId, bankAccId } = {}) => {
        const params = new URLSearchParams();
        if (vaAccountId) params.set("vaAccountId", vaAccountId);
        if (busEntId) params.set("busEntId", busEntId);
        if (bankAccId) params.set("bankAccId", bankAccId);
        const response = await axios.get(
            `/api/admin/getWalletTxns?${params.toString()}`
        );
        return response.response;
    }
)



export const walletsSlice = createSlice({
    name: 'wallets',
    initialState: {
        loading: false,
        status: [],
        wallet: [],
        entBusWallet: [],
        karncyWallet: [],
        platformWallet: [],
        walletDetailedView: [],
        error: '',
    },

    extraReducers: (builder) => {
        builder.addCase(getUsersWallet.pending, (state) => {
            state.loading = true;
            state.error = '';
        });
        builder.addCase(getUsersWallet.fulfilled, (state, action) => {
            state.loading = false;
            state.wallet = action.payload;

        });
        builder.addCase(getUsersWallet.rejected, (state, action) => {
            state.loading = false;
            state.wallet = [];
            state.error = action.error.message;
        });

        builder.addCase(getBusEntWallet.pending, (state) => {
            state.loading = true;
            state.error = '';
        });
        builder.addCase(getBusEntWallet.fulfilled, (state, action) => {
            state.loading = false;
            state.entBusWallet = action.payload;

        });
        builder.addCase(getBusEntWallet.rejected, (state, action) => {
            state.loading = false;
            state.entBusWallet = [];
            state.error = action.error.message;
        });

        builder.addCase(getPlatformWallets.pending, (state) => {
            state.loading = true;
            state.error = '';
        });
        builder.addCase(getPlatformWallets.fulfilled, (state, action) => {
            state.loading = false;
            state.platformWallet = action.payload;

        });
        builder.addCase(getPlatformWallets.rejected, (state, action) => {
            state.loading = false;
            state.platformWallet = [];
            state.error = action.error.message;
        });


        builder.addCase(getKarncyWallets.pending, (state) => {
            state.loading = true;
            state.error = '';
        });
        builder.addCase(getKarncyWallets.fulfilled, (state, action) => {
            state.loading = false;
            state.karncyWallet = action.payload;

        });
        builder.addCase(getKarncyWallets.rejected, (state, action) => {
            state.loading = false;
            state.karncyWallet = [];
            state.error = action.error.message;
        });

        builder.addCase(getTransactions.pending, (state) => {
            state.loading = true;
            state.error = '';
        });
        builder.addCase(getTransactions.fulfilled, (state, action) => {
            state.loading = false;
            state.walletDetailedView = action.payload;

        });
        builder.addCase(getTransactions.rejected, (state, action) => {
            state.loading = false;
            state.walletDetailedView = [];
            state.error = action.error.message;
        });
    },

    reducers: {
    }
})

// eslint-disable-next-line no-empty-pattern
export const { } = walletsSlice.actions

export default walletsSlice.reducer